export default "__VITE_ASSET__BtRLs6xg__"